import { createSelector } from 'reselect';
import { selectRouteParams } from 'selectors/general';

export const selectToken = createSelector(selectRouteParams, routeParams => routeParams.token || '');
